import 'babel-polyfill'
import axios from 'axios'
import qs from 'qs'
import { url } from './common'
axios.defaults.timeout = 7000
export const readServer = {
  json: (url) => {
    return axios.get(url).then(res => res.data)
  }
}
export const baseServer = {
  getImg: (params) => {
    return axios.post(`${url}/oss/getPath`, qs.stringify(params)).then(res => res.data)
  }
}
export const officialSiteServer = {
  getTeamDetail: (params) => {
    return axios.get(`${url}/officialSite/getTeamDetail`, { params: params }).then(res => res.data)
  },
  getTeamMemberList: (params) => {
    return axios.get(`${url}/officialSite/getTeamMemberList`, { params: params }).then(res => res.data)
  },
  index: (params) => {
    return axios.get(`${url}/officialSite/index`, { params: params }).then(res => res.data)
  },
  queryCompetition: (params) => {
    return axios.get(`${url}/officialSite/queryCompetition`, { params: params }).then(res => res.data)
  },
  queryCooperator: (params) => {
    return axios.get(`${url}/officialSite/queryCooperator`, { params: params }).then(res => res.data)
  },
  queryRotate: (params) => {
    return axios.get(`${url}/officialSite/queryRotate`, { params: params }).then(res => res.data)
  },
  queryTeamList: (params) => {
    return axios.get(`${url}/officialSite/queryTeamList`, { params: params }).then(res => res.data)
  }
}
// 教学成果
export const subjectServer = {
  // 课题立项
  getSubjectList: (params) => {
    return axios.get(`${url}/officialSite/selProjectList`, { params: params }).then(res => res.data)
  },
  // 课题立项
  getThesisList: (params) => {
    return axios.get(`${url}/officialSite/selThesisList`, { params: params }).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js